var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Slot } from 'radix-ui';
import * as React from 'react';
import { cn } from '../../lib/utils.js';
/**
 * A bare interactive element with no visual button styles applied.
 * Renders a native `<button>` (or the child element when `asChild` is true)
 * with only focus-ring and disabled-state styles. Use `className` to fully
 * control appearance — intended for clickable-card patterns.
 */
export function UnstyledButton(_a) {
    var className = _a.className, asChild = _a.asChild, props = __rest(_a, ["className", "asChild"]);
    var Comp = asChild ? Slot.Root : 'button';
    return (<Comp {...(!asChild && { type: 'button' })} className={cn('focus-visible:border-ring focus-visible:ring-ring/70 cursor-pointer outline-none focus-visible:ring-2 disabled:pointer-events-none disabled:opacity-50', className)} {...props}/>);
}
